import FilesTable from './FilesTable'

export default FilesTable
